import { productFamilyCodes } from 'types/productFamilyCodes';

const groupProductFamilies = [
  productFamilyCodes.BSG,
  productFamilyCodes.BSG1,
  productFamilyCodes.BSG2,
  productFamilyCodes.BSG3,
  productFamilyCodes.BSG4,
  productFamilyCodes.CHARTER,
  productFamilyCodes.CHARTER_TOLLABLE,
  productFamilyCodes.EDUCATION,
  productFamilyCodes.GROUP,
  productFamilyCodes.MICEGROUP,
  productFamilyCodes.OSGRP,
  productFamilyCodes.PARALYMPIC,
  productFamilyCodes.PARALYMPIC_BE,
  productFamilyCodes.PARALYMPIC_NL,
  productFamilyCodes.TEAMBE,
  productFamilyCodes.TEAMDE,
  productFamilyCodes.TEAMGB,
  productFamilyCodes.TEAMNL,
  productFamilyCodes.EX_CARRIAGE
];

export const passengerDetailsGroupProductFamilies = [productFamilyCodes.EDUCATION];

export default groupProductFamilies;
